import { ApiService } from "../../constants";
import { HttpService } from "../../utilities";
import { FETCH_LANDING_CONFIG, SET_LANDING_CONFIG } from "./ConfigTypes";

export const fetchLandingConfig = () => async (dispatch: any) => {
  
  dispatch({
    type: FETCH_LANDING_CONFIG
  });

  HttpService.post(
    ApiService.icdc.module.landingPage.getConfig, 
    {}
  )
  .then(resp => {

    dispatch({
      type: SET_LANDING_CONFIG,
      payload: resp?.data
    });
    
    return resp?.data
  }) 
}
